import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Modal } from '../ui/Modal';

interface CreateAgentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string, avatarUrl: string) => Promise<void>;
  creating: boolean;
}

export const CreateAgentModal: React.FC<CreateAgentModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  creating,
}) => {
  const [agentName, setAgentName] = useState('');
  const [avatarUrl, setAvatarUrl] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!agentName.trim()) return;

    await onSubmit(agentName.trim(), avatarUrl.trim());
    setAgentName('');
    setAvatarUrl('');
  };

  const handleClose = () => {
    if (!creating) {
      setAgentName('');
      setAvatarUrl('');
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="md"
      title="Create New Agent"
      closeOnOverlayClick={!creating}
      className="!bg-slate-800 !border !border-slate-700"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <Input
          id="agentName"
          label="Agent Name"
          type="text"
          value={agentName}
          onChange={(e) => setAgentName(e.target.value)}
          placeholder="e.g., Sales Bot, Support Assistant"
          disabled={creating}
          required
          className="!text-white [&_input]:!bg-slate-900 [&_input]:!border-slate-700 [&_input]:!text-white [&_input]:placeholder-slate-500 [&_label]:!text-slate-300"
        />

        <Input
          id="agentAvatar"
          label="Avatar URL (optional)"
          type="url"
          value={avatarUrl}
          onChange={(e) => setAvatarUrl(e.target.value)}
          placeholder="https://example.com/avatar.png"
          disabled={creating}
          className="!text-white [&_input]:!bg-slate-900 [&_input]:!border-slate-700 [&_input]:!text-white [&_input]:placeholder-slate-500 [&_label]:!text-slate-300"
        />

        <div className="flex gap-3 pt-4">
          <Button
            type="submit"
            variant="primary"
            loading={creating}
            disabled={creating || !agentName.trim()}
            className="flex-1 !bg-blue-600 hover:!bg-blue-700 disabled:!bg-slate-700"
          >
            {creating ? 'Creating...' : 'Create Agent'}
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={handleClose}
            disabled={creating}
            className="flex-1 !bg-slate-700 hover:!bg-slate-600 !text-white !border-0"
          >
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
};
